import React, { useState } from 'react';
import { Modal, Button, Form, DatePicker, Select } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave } from '@fortawesome/free-solid-svg-icons';
import { solderFactureByPartenaire } from '../factures/facture.reducer';
import { useAppDispatch, useAppSelector } from 'app/config/store';
interface SolderFactureModalProps {
  facture: string;
  inactiveAnnee: boolean;
  handleDisable: () => boolean;
}
const SolderFactureModal: React.FC<SolderFactureModalProps> = ({ facture, inactiveAnnee, handleDisable }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const dispatch = useAppDispatch();
  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleSubmit = values => {
    const factureData = {
      factureId: facture,
      moyenPaiement: values.moyenPaiement,
      datePaiement: values.datePaiement,
    };
    dispatch(solderFactureByPartenaire({ factureId: facture, factureData }));
    setIsModalVisible(false);
  };

  return (
    <>
      <Button onClick={showModal} disabled={handleDisable()} style={{ backgroundColor: '#579587', color: 'white', fontWeight: 'bold' }}>
        Solder la facture
      </Button>

      <Modal title="Solder la facture" centered visible={isModalVisible} onCancel={handleCancel} footer={null}>
        <Form labelCol={{ span: 8 }} wrapperCol={{ span: 14 }} layout="horizontal" size="large" onFinish={handleSubmit}>
          <Form.Item label="Date de paiement" name="datePaiement" rules={[{ required: true, message: 'Veuillez choisir l’heure' }]}>
            <DatePicker showTime />
          </Form.Item>

          <Form.Item
            label="Moyen de paiement"
            name="moyenPaiement"
            rules={[{ required: true, message: 'Veuillez choisir un moyen de paiement' }]}
          >
            <Select placeholder="Sélectionner le moyen de paiement">
              <Select.Option value="OM">ORANGE MONEY</Select.Option>
              <Select.Option value="WAVE">WAVE</Select.Option>
            </Select>
          </Form.Item>

          <Form.Item wrapperCol={{ offset: 8, span: 14 }}>
            <Button type="primary" htmlType="submit" style={{ backgroundColor: '#579587', color: 'white' }}>
              <FontAwesomeIcon icon={faSave} />
              &nbsp; Solder la facture
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default SolderFactureModal;
